(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
function createStickyHeader() {
  const header = document.querySelector("header");
  const headerBG = document.querySelector("#headerBG");
  const mobileMenu = document.querySelector("#mobileMenu");
  const toggle = document.querySelector("[data-toggle]");
  const body = document.querySelector("body");

  let prevScrollPos = window.pageYOffset;
  mobileMenu.addEventListener("toggle", function() {
    headerBG.style.backgroundColor = mobileMenu.open ? "#FFFBF2" : "";
  });

  if(toggle) {
    toggle.addEventListener("toggle", (event) => {
      window.toggle = toggle.open;
      if(window.toggle) {
        header.style.top = 0
        body.classList.add("overflow-hidden")
      } else {
        body.classList.remove("overflow-hidden")
      }
    });
  }

  window.addEventListener("scroll", function() {
    const headerHeight = header.offsetHeight;
    let currentScrollPos = window.pageYOffset;
    let deltaY = currentScrollPos - prevScrollPos;

    if(window.toggle) {
      header.style.top = 0
    } else if ((deltaY < 0 || currentScrollPos < 0)) {
      header.style.top = Math.min(0, header.getBoundingClientRect().top - deltaY) + "px";
    } else {
      header.style.top = Math.max(-headerHeight, header.getBoundingClientRect().top - deltaY) + "px";
    }
    prevScrollPos = currentScrollPos;
  });
  document.addEventListener('click', function(event) {
    if (!event.target.closest('details[open]')) {
      let details = document.querySelector('details[open]');
      if (details) {
        const dropdownInstance = details.dropdownInstance;
        if (dropdownInstance) {
          dropdownInstance.shrink();
        } else { 
          details.removeAttribute('open');
        }
      }
    }
  });
}

window.onload = createStickyHeader;


window.closeDetails = function() {
  const details = document.querySelector('details[open]');
  if (details) {
    const dropdownInstance = details.dropdownInstance;
    if (dropdownInstance) {
      dropdownInstance.shrink();
    } else { 
      details.removeAttribute('open');
    }
  }
}
  
class Dropdown {
  constructor(el) {
    this.el = el;
    this.summary = el.querySelector('summary.menu-dropdown');
    this.content = el.querySelector('.dropdown-menu');

    this.animation = null;
    this.isClosing = false;
    this.isExpanding = false;
    this.el.dropdownInstance = this;
    if(this.summary) {
      this.summary.addEventListener('click', (e) => this.onClick(e));
    }
  }

  onClick(e) {
    e.preventDefault();
    if (this.isClosing || !this.el.open) {
      this.open();
    } else if (this.isExpanding || this.el.open) {
      this.shrink();
    }
  }

  shrink() {
    this.isClosing = true;
    const isDropdown = this.content.classList.contains('dropdown-abs');
    const elementToAnimate = isDropdown ? this.content : this.el;
    const startHeight = `${isDropdown ? this.content.offsetHeight : this.el.offsetHeight}px`;
    const endHeight = `${isDropdown ? 0 : this.summary.offsetHeight}px`; 
    
    if (this.animation) {
      this.animation.cancel();
    }
    elementToAnimate.style.overflow = 'hidden';
    this.animation = elementToAnimate.animate({
      height: [startHeight, endHeight]
    }, {
      duration: 500,
      easing: 'ease-out'
    });
    this.animation.onfinish = () => this.onAnimationFinish(false);
    this.animation.oncancel = () => this.isClosing = false;
  }

  open() {
    this.el.style.height = `${this.el.offsetHeight}px`;
    this.el.open = true;
    window.requestAnimationFrame(() => this.expand());
  }

  expand() {
    this.isExpanding = true;
    const isDropdown = this.content.classList.contains('dropdown-abs');
    const startHeight = `${isDropdown ? 0 : this.el.offsetHeight}px`;
    const endHeight = `${isDropdown ? this.content.offsetHeight : this.summary.offsetHeight + this.content.offsetHeight}px`;
    const elementToAnimate = isDropdown ? this.content : this.el;
    
    if (this.animation) {
      this.animation.cancel();
    }
    elementToAnimate.style.overflow = 'hidden';
    this.animation = elementToAnimate.animate({
      height: [startHeight, endHeight]
    }, {
      duration: 500,
      easing: 'ease-out'
    });
    this.animation.onfinish = () => this.onAnimationFinish(true);
    this.animation.oncancel = () => this.isExpanding = false;
  }

  onAnimationFinish(open) {
    this.el.open = open;
    this.animation = null;
    this.isClosing = false;
    this.isExpanding = false;
    const isDropdown = this.content.classList.contains('dropdown-abs');
    const elementToReset = isDropdown ? this.content : this.el;
    elementToReset.style.height = elementToReset.style.overflow = '';
  }
}

document.querySelectorAll('.dropdown').forEach((el) => {
  new Dropdown(el);
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ogt-coming-soon"]) return;
  try {
    
    // Get the countdown date
    let countDownDate = new Date(document.querySelector('[data-countdown-date]').dataset.countdownDate).getTime();

    //setInterval calls a function at specified intervals
    var x = setInterval(function(){
        // Get todays date and time
        let now = new Date().getTime();

        // Distance between preset and countdown date
        let distance = countDownDate - now;

        //Time calculations
        let days = Math.floor(distance / (1000 * 60 * 60 * 24));
        let hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        let minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));

        //Add results
        document.querySelector(".days").innerHTML = days;
        document.querySelector(".hours").innerHTML = hours;
        document.querySelector(".minutes").innerHTML = minutes;
    },1000)

  } catch(e) { console.error(e); }
})();
})();
